import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import EntitiesSelector from './EntitiesSelector'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const WorkingRegimesSelector = ({ className = '', empty = false, disabled, reverse = false, style = {}, values = [], dropdownRender, onChange }) => {
  const { workingRegimes } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  const entityOptions = useMemo(() => workingRegimes.map(wk => {
    return { value: wk.id, entity: wk, label: t(wk.name), tooltip: wk.name }
  }), [workingRegimes, reverse, t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={entityOptions}
      multiple='default'
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default WorkingRegimesSelector
